import {course_getCourseClassTransferHistory_Api} from 'apis'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {withReportTable} from 'views/Workspace/Examination/renderReportTable'
import TransferReportFilter from '../components/filters/TransferReportFilter'
import {BsInfoCircle} from "react-icons/bs";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import TooltipApp from "components/TooltipApp";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {renderIf} from "../../../Shared";
import {formatDate} from "../../../../helpers/datetimeHelpers";

const headers = ['fullname', 'from class', 'to class', 'date']

const schemas = [
    {
        name: 'student',
        value_path: 'student',
        value2_path: 'student',
        className: 'font-bold text-color-000 whitespace-no-wrap',
        render: (value) => {
            const phone = _.get(value, 'contact_phone')
            const email = _.get(value, 'contact_email')

            return (
                <div className="space-x-2">
            <span className="font-semibold text-color-100 whitespace-no-wrap">
              {value?.fullname}
            </span>
                    <TooltipApp
                        placement="right"
                        color="background"
                        title={renderIf(
                            _.some([phone, email]),
                            <DoubleValueItem
                                labelFirst=""
                                valueFirst={phone}
                                iconSecond={email ? ' - ' : ''}
                                valueSecond={email}
                                className="flex items-center text-xs text-color-300 italic"
                            />
                        )}>
                        <BsInfoCircle size={13} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                </div>
            )
        },
        render2: (value) => null,
    },
    {
        name: 'from_course_class',
        value_path: 'from_course_class',
        className: 'font-medium text-color-100 italic ',
        render: (value) => value?.title,
    },
    {
        name: 'to_course_class',
        value_path: 'to_course_class',
        className: 'font-medium text-color-100 italic',
        render: (value) => value?.title,
    },
    {
        name: 'transfer_date',
        value_path: 'transfer_date',
        className: 'text-color-300 italic whitespace-no-wrap',
        render: (value) => formatDate(value, 'DD/MM/YYYY'),
    },
]

const TransferReport = ({
                            owner_id,
                            owner_type,
                            filter_actions = {
                                sortBy: 'sort-by',
                                keyword: 'keyword',
                                course_id: 'course-id',
                                course_class_id: 'class-id',
                            },
                        }) => {
    const t = useTranslate()

    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const course_id = useRouteSearchParam(filter_actions.course_id)

    const course_class_id = useRouteSearchParam(filter_actions.course_class_id)

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, location.state]
    )

    const [pager_widget, {widget_header}] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                course_id,
                course_class_id,
            })
        },
        pagerInfo: {
            query: bindQueryParam({
                id: course_id,
            }),
            values: {
                course_class_id,
            },
            PaginationMeta: NullAsDefault,
            apiInfo: course_getCourseClassTransferHistory_Api,
            ...withReportTable(headers, schemas),
        },
        withKey: createPagerKey(refresh_deps),
        dependencies: [owner_id, owner_type],
        filter_params: {
            owner_id,
            owner_type,
            course_id,
            course_class_id,
        },
        renderSortBy: NullAsDefault,
        SortByWidget: NullAsDefault,
        renderSearchBar: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        AdvancedFilter: TransferReportFilter,
    })
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col flex-1">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                    {t('report')}
                </h2>
                <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
            </div>
            <div className="p-4 border border-color-50 background shadow-md rounded-xl">
                <div className="flex flex-col gap-6">
                    <div className="text-center font-bold text-lg text-gray-700 uppercase tracking-widest mb-4">
                        {t('transfer records')}
                    </div>
                    {course_class_id ? pager_widget : widget_header}
                </div>
            </div>
        </div>
    )
}

export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(TransferReport)
